<template>
    <div class="biz-wallet-withdraw">
        <modal class="withdraw-modal" :display="modalStatus.bizWalletWithdraw"  @modalStatus="closeModal()" >
            <h1>輸入提領金額</h1>
            <div class="content" v-if="withdrawState == 0">
                <div class="name">
                    <span>可提領餘額</span>
                    <div class="money">
                        <span class="sign">
                            $
                        </span>
                        <div class="number">
                            {{toCurrency(userBalance)}}
                        </div>
                    </div>
                </div>
                <div class="price">
                    <span>提領金額</span>
                    <div class="input-error-group">
                        <input type="text" v-model="withdraw.price" >
                        <span v-show="error.withdraw" class="error">{{error.withdraw}}</span>
                    </div>
                </div>
                <div class="bank" >
                    <span>選擇提領帳戶</span>
                    <rent-select :key="componentKey" refName="bank" :selectMsg="defaultBankName" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                        <ul>
                            <li :data-id="card.cid" :data-name="card.bankName" :data-acc="bankAccountEncrypt(card.bankAccountNo)" v-for="(card,index) in bankCardList" :key="index">
                                {{card.bankName}}帳戶 （ {{bankAccountEncrypt(card.bankAccountNo)}}）
                            </li>
                        </ul>
                    </rent-select>
                </div>
            </div>
            <div class="content" v-if="withdrawState == 1">
                <div class="list">
                    <span class="title">申請時間</span>
                    <span class="info">{{today}}</span>
                </div>
                <div class="list">
                    <span class="title">轉入帳號</span>
                    <span class="info">{{seletedBank.name}}帳戶 （ {{seletedBank.account}}）</span>
                </div>
                <div class="list">
                    <span class="title">提領金額</span>
                    <span class="info">$ {{toCurrency(withdraw.price)}}</span>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button" v-if="withdrawState == 0" :disabled="disabledState" @click="withdrawState=1">下一步</button>
                <button class="default-button" v-if="withdrawState == 1" @click="withdrawAmount">確認提領</button>
                <button class="border-button" @click="closeModal('withdraw')">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelect from '@/components/bussiness/widges/tools/RentSelect.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            componentKey: 0,
            withdrawState: 0,
            disabledState: true,
            defaultBankName: null,
            seletedBank: {
                name: null,
                account: null,
            },
            withdraw:{
                price: null,
                account: null
            },
            error:{
                withdraw: ''
            },
            isDefault: false,
        }
    },
    // mounted() {
    //     this.$analytics.logEvent('新增委託_ATM付款', { screen_name: '新增委託_ATM付款'})
    // },
    watch: {
        withdraw: {
            handler: function (newValue, oldValue) {
                let numerical = /^[0-9]*$/
                if(newValue.price){
                    if( numerical.test(newValue.price) ){
                        this.error.withdraw = ''
                        if( newValue.price > parseFloat(this.userBalance)){
                            this.error.withdraw = '餘額不足'
                        }else if(newValue.price > 100000){
                            this.error.withdraw = '最大提領金額為10萬'
                        }else{
                            this.error.withdraw = ''
                        }
                    }else{
                        this.error.withdraw = '請輸入數字'
                    }
                }
                if( newValue.price && newValue.account && !this.error.withdraw){
                    this.disabledState = false
                }else{
                    this.disabledState = true
                }
                // this.$store.dispatch('setHouseList',newValue)
            },
            deep: true
        },
        bankCardList: {
            handler: function (val) {
                // console.log(val)
                this.defaultBankInfo(val)
            },
            deep: true
        },
    },
    methods: {
        getSelectId: function (value) {
            this.isDefault = false

            if( value.ref == 'bank' ){
                this.withdraw.account = event.target.dataset.id
                this.seletedBank.name = event.target.dataset.name
                this.seletedBank.account = event.target.dataset.acc
            }else if( value.ref == 'withdraw' ){
                this.withdrawFilterState = value.id
            }
        },
        bankAccountEncrypt: function (account) {
            return '*****'+account.substr(5)
        },
        defaultBankInfo: function (bankList) {
            bankList.map( item =>{
                if(item.default == true){
                    this.componentKey += 1;
                    this.withdraw.account = item.cid
                    this.defaultBankName = item.bankName+'（'+ this.bankAccountEncrypt(item.bankAccountNo) +'）'
                    this.seletedBank.account = this.bankAccountEncrypt(item.bankAccountNo)
                    this.seletedBank.name = item.bankName
                }
            })
        },
        withdrawAmount: function () {
            this.$analyticsBiz.logEvent('送出提領', { screen_name: '送出提領'})
            let data = {
                "bankAccountId" : this.withdraw.account,
                "currencyType" : "TWD",
                "withdrawAmount" : this.withdraw.price
            }
            console.log(data)
            this.$store.dispatch('bizWithdrawWallet', data)
            .then( () => {
                this.closeModal()
                this.withdrawState = 0
                this.withdraw = {
                    price: null,
                    account: null
                }
                this.defaultBankInfo(this.bankCardList)
            })

            // apiWithwraw(data)
            // .then(res => {
            //     // console.log(res)
            //     if(res.data.status == "SUCCESS"){
            //         this.closeModal('withdraw')
            //         this.$store.dispatch('getUserBalance')
            //         this.$store.dispatch('getTransRecord', 1)
            //         this.alart.success = true
            //         this.msg.success = '提領審核中'
            //     }else{
            //         this.alart.fail = true
            //         this.msg.fail = res.data.errorMsg
            //         this.closeModal('withdraw')
            //     }
            // })
            // .catch(err => {
            //     this.alart.fail = true
            //     this.msg.fail = err
            //     console.log(err)
            // })
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'bizWalletWithdraw'})
        },
    },
    computed: {
        today: function () {
            if(this.withdrawState == 1){
                var formatDate = [];
                var date = new Date();
                //一般日期 年 月 天 時 分
                formatDate[0] = date.getFullYear();
                formatDate[1] = date.getMonth()+1;
                formatDate[2] = date.getDate();
                formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
                formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
                formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
                //月及天兩位數
                formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
                formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
        
                return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4]+':'+formatDate[5];
            }
        },
        ...mapGetters({
            bankCardList: 'GET_BIZ_BANK_CARD_LIST',
            userBalance: 'GET_BIZ_BALANCE',
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSelect
    }
}
</script>
<style lang="scss"  >
    .biz-wallet-withdraw{
        .modal-content{
            width: 448px;
            padding: 0 !important;
            .detail{
                align-items: unset !important;
                h1{
                    margin: 0 auto;
                    margin-top: 36px;
                    margin-bottom: 24px;
                }
                .alarm-msg{
                    padding: 8px 32px;
                    margin-bottom: 30px;
                    font-size: 16px;
                    font-weight: 500;
                    color: #fc7171;
                    background-color: rgba(240, 90, 62, 0.1);
                    line-height: 1.7;
                }
                .content{
                    min-height: 336px;
                    padding: 0 32px 10px 32px;
                    // margin-bottom: 52px;
                    >div{
                        margin-bottom: 30px;
                        >span{
                            display: block;
                            margin-bottom: 12px;
                        }
                        input{
                            width: 100%;
                        }
                    }
                    .price{
                        margin-bottom: 48px;
                    }
                    .bank{
                        span{
                            color: #676362 !important;
                        }
                    }
                    .list{
                        display: flex;
                        margin-bottom: 20px;
                        .title{
                            display: block;
                            width: 56px;
                            color: #a8a5a4;
                            margin-right: 22px;
                        }
                    }
                    .money{
                        position: relative;
                        display: flex;
                        align-items: flex-end;
                        color: #ff9275;
                        .sign{
                            position: absolute;
                            font-size: 12px;
                            font-weight: 500;
                            bottom: 5px;
                            color: #ff9275;
                        }
                        .number{
                            margin-left: 12px;
                            font-size: 32px;
                        }
                    }
                }
                .content::-webkit-scrollbar {
                    display: none;
                }
                .btn-group{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                    height: 84px;
                    box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                    border-radius:  0 0 20px 20px;
                    margin: 0 auto;
                    button{
                        width: 184px;
                        height: 44px;
                    }
                    button:first-child{
                        margin-right: 14px;
                    }
                }
            }
            
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/modals/walletWithdraw.vue